
export default {
    data() {
        return {
            pageTypeNumber: ''
        };
    },
    mounted() {
        // 获取查询的岗位发布分类
        let type = this.$store.state.pageType === 'social' ? 1 : this.$store.state.pageType === 'campus' ? 2 : this.$store.state.pageType === 'worker' ? 3 : '';
        if (!type) {
            for (const item of [{ key: '/social/', type: 1 }, { key: '/campus/', type: 2 }, { key: '/worker/', type: 3 }]) {
                if (this.$route.path.indexOf(item.key) !== -1) {
                    type = item.type;
                    break;
                }
            }
        }
        if (!type) {
            for (const value of [{ key: '/social', type: 1 }, { key: '/campus', type: 2 }, { key: '/worker', type: 3 }]) {
                if (this.$route.path.indexOf(value.key) !== -1) {
                    type = value.type;
                    break;
                }
            }
        }
        this.pageTypeNumber = type;
    }
};
